export const runder = [
  {
    heads: "No more manual time trackers",
    texts:
      "Fully automatic start and end times, no manual entry, and no human error – the automatic time tracker starts up as soon as you open the computer and stops when you close it.",
  },
  {
    heads: "Oversee work progress",
    texts:
      "With URL and document title tracking it's easy to always be informed about your team's overall progress and habits during work hours.",
  },
  {
    heads: "Optimize your resources",
    texts:
      "Estimate project costs, assign hourly rates, issue invoices, and control expenses. Project management is easy when you have a birdseye view of all ongoing processes.",
  },
  {
    heads: "Run your office smoothly",
    texts:
      "DeskTime isn't just a time tracker. You can assign shifts and oversee absences, stay informed about remote workers and run a hybrid office all on one platform.",
  },
];
